import { createContext } from "react";

export const WorkspaceContext = createContext(null);
